import { IApiResponse } from "clients/AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostRetryTransactionRequest } from "./postRetryTransaction.schema";

export const postRetryTransaction = (axios: IAxiosInstance) => {
  return async (data: TPostRetryTransactionRequest) => {
    const response = await axios.noRetry.post<IApiResponse<unknown>>(
      `/transactions/retry`,
      data
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
